import { Fragment } from 'react';
import settings from '@/settings';
import { getOptions } from './constants';

const categoryCount = getOptions()?.[settings.store]?.length ?? 0;

// Rendered height of the circular economy block, measured per breakpoint
const CircularEconomyPlaceholder = () => (
  <div className="min-h-[566px] xs:min-h-[455px] sm:min-h-[552px] md:min-h-[497px] lg:min-h-[458px] xl:min-h-[549px]" />
);

// Mirrors the layout of Categories (one 365px carousel per category, with the
// circular economy block after the second) while its chunk loads.
const CategoriesPlaceholder = () => {
  if (!categoryCount) {
    return <CircularEconomyPlaceholder />;
  }

  return (
    <>
      {Array.from({ length: categoryCount }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          <div className="h-[365px] bg-white" />
          {index === 1 && <CircularEconomyPlaceholder />}
        </Fragment>
      ))}
    </>
  );
};

export default CategoriesPlaceholder;
